import React, { useState, useEffect } from 'react'
import { getAllData, deleteIdData } from '../../lib/resourcecenterview'
import { useAuth } from '../../_helper/Auth/AuthProvider'
import { DataManagementGrid } from '../Common/DataManagementGrid'
import { resourceColumns } from '../../Data/ResourceManagement/ResourceListData'
import ResourceModal from './ResourceModal'

const InstructorResourceList = () => {
	const [resources, setResources] = useState([])
	const [searchQuery, setSearchQuery] = useState('')
	const [loading, setLoading] = useState(true)
	const [isModalOpen, setIsModalOpen] = useState(false)
	const [editingResource, setEditingResource] = useState(null)
	const [isDarkMode, setIsDarkMode] = useState(false)

	const { user } = useAuth()

	const getData = async () => {
		try {
			setLoading(true)
			const data = await getAllData()
			setResources(data)
		} catch (error) {
			console.error('Error fetching resource data:', error)
		} finally {
			setLoading(false)
		}
	}

	const handleDelete = async (id) => {
		const choice = window.confirm('Are you sure you want to delete?')
		if (choice) {
			try {
				await deleteIdData(id)
				getData()
			} catch (error) {
				console.error('Error deleting resource:', error)
			}
		}
	}

	useEffect(() => {
		if (user?.id) {
			getData()
		}
	}, [user?.id])

	useEffect(() => {
		const checkDarkMode = () => {
			setIsDarkMode(document.body.classList.contains('dark-only'))
		}
		checkDarkMode()
		const observer = new MutationObserver(checkDarkMode)
		observer.observe(document.body, { attributes: true, attributeFilter: ['class'] })
		return () => observer.disconnect()
	}, [])

	const handleEdit = (resource) => {
		setEditingResource(resource)
		setIsModalOpen(true)
	}

	const handleAdd = () => {
		setEditingResource(null)
		setIsModalOpen(true)
	}

	const toggleModal = () => {
		setIsModalOpen(!isModalOpen)
	}

	return (
		<>
			<DataManagementGrid
				title="Resource Center"
				subTitle="Manage educational resources"
				breadcrumbTitle="Resource Center"
				breadcrumbMainTitle="Resource Management"
				columns={(layout, role) => resourceColumns(layout, role, handleEdit)}
				data={resources}
				loading={loading}
				searchQuery={searchQuery}
				setSearchQuery={setSearchQuery}
				searchPlaceholder="Search resources..."
				createButtonText="Add Resource"
				additionalActionButton={
					<button onClick={handleAdd} className="btn btn-primary">
						<i className="fa fa-plus me-2"></i>
						Add Resource
					</button>
				}
				onDelete={handleDelete}
				searchFields={['pname', 'howuse', 'name', 'surname']}
				noDataMessage="No resources found"
			/>
			<ResourceModal
				isOpen={isModalOpen}
				toggle={toggleModal}
				instructorId={user?.id}
				editingResource={editingResource}
				onSave={getData}
				isDarkMode={isDarkMode}
			/>
		</>
	)
}

export { InstructorResourceList }
